// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__vSNLh","col":"CardReaderDesc_col__3j-Hm","label":"CardReaderDesc_label__1Gv0k"};